<template>
  <div>
    <!-- 总 -->
    <!-- about us -->
    <div
      style="
        height: 145px;
        background: #0067b3;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 35px;
      "
    >
      {{ $t("公司介绍.公司介绍") }}
    </div>
    <!-- about us -->

    <!-- 第一大块 白色 2图 文字  -->
    <div style="padding: 30px 10% 30px 10%">
      <!-- 上方大图 -->
      <div style="display: flex; justify-content: space-around">
        <img
          src="https://upload-attch-1256082024.cos.ap-beijing.myqcloud.com/jf/jf_web_img/company.png"
          alt="图片加载失败"
          style="width: 100%; height: auto; object-fit: cover"
        />
      </div>
      <!-- 上方大图 -->

      <!-- 下方左右两部分 -->
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: stretch; /* 确保左右两部分的高度一致 */
          margin-top: 30px;
          height: 100%; /* 确保容器高度可以撑满 */
        "
      >
        <!-- 左侧文本 -->
        <div
          style="
            flex-grow: 1;
            padding-right: 30px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            font-size: calc(1.5vh + 1vw); /* 保持当前的文本大小关系 */
            height: 100%; /* 确保左侧区域高度适应其容器 */
          "
        >
          <!-- 上方文本 -->
          <div
            style="
              color: #0067b3;
              font-weight: bold;
              margin-bottom: calc(1vh + 15px);
            "
          >
            {{ $t("公司介绍.叉车租赁已达19年") }}
          </div>
          <div>
            <!-- 我们提供 -->
            <div
              style="
                color: #0067b3;
                margin-bottom: calc(0.9vh + 7px);
                font-weight: bold;
              "
            >
              {{ $t("公司介绍.我们提供") }}
            </div>
            <!-- 五类叉车 -->
            <div>
              <div
                class="blue-circle"
                style="
                  margin-bottom: calc(0.7vh + 5px);
                  font-size: calc(0.9vh + 5px); /* 保持当前的文本大小关系 */
                "
              >
                {{ $t("公司介绍.多样化的租赁模式") }}
              </div>
              <div
                class="blue-circle"
                style="
                  margin-bottom: calc(0.7vh + 5px);
                  font-size: calc(0.9vh + 5px); /* 保持当前的文本大小关系 */
                "
              >
                {{ $t("公司介绍.完善的售后回租业务") }}
              </div>
              <div
                class="blue-circle"
                style="
                  margin-bottom: calc(0.7vh + 5px);
                  font-size: calc(0.9vh + 5px); /* 保持当前的文本大小关系 */
                "
              >
                {{ $t("公司介绍.一体化的服务网络") }}
              </div>
              <div
                class="blue-circle"
                style="
                  margin-bottom: calc(0.7vh + 5px);
                  font-size: calc(0.9vh + 5px); /* 保持当前的文本大小关系 */
                "
              >
                {{ $t("公司介绍.专业化的服务团队") }}
              </div>
              <div
                class="blue-circle"
                style="
                  margin-bottom: calc(0.7vh + 5px);
                  font-size: calc(0.9vh + 5px); /* 保持当前的文本大小关系 */
                "
              >
                {{ $t("公司介绍.保障性的服务方案") }}
              </div>
            </div>
            <!-- 五类叉车 -->
          </div>
        </div>
        <!-- 左侧文本 -->
        <!-- 右侧图片 -->
        <div
          style="display: flex; align-items: center; width: 60%; height: 100%"
        >
          <img
            src="@/assets/huoban.png"
            style="width: 100%; height: auto; object-fit: contain"
          />
        </div>
        <!-- 右侧图片 -->
      </div>
      <!-- 下方左右两部分 -->
    </div>
    <!-- 第一大块 白色 2图 文字 -->

    <!-- 第二块视频 -->
    <div
      style="
        padding: 30px 10% 30px 10%;
        margin: 0px 0px 0px 0px;
        background-color: #cbcbcb;
      "
    >
      <div style="display: flex; justify-content: space-around">
        <video
          style="width: 100%"
          controls=""
          preload="auto"
          poster="https://upload-attch-1256082024.cos.ap-beijing.myqcloud.com/jf/jf_web_img/shipinfengmian.png"
        >
          <source
            src="https://upload-attch-1256082024.cos.ap-beijing.myqcloud.com/jf/jf_web_img/xuanchuanshipin.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    </div>
    <!-- 第二块视频 -->

    <!-- 仓库环境 -->
    <div
      style="
        height: 145px;
        background: #0067b3;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 35px;
      "
    >
      {{ $t("公司介绍.叉车租赁") }}
    </div>
    <!-- 仓库环境 -->
    <!-- 第一组标题 -->
    <div
      style="
        margin: 50px 0px 5px 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #0067b3;
        font-size: 30px;
        font-weight: bold;
      "
    >
      {{ $t("公司介绍.租赁模式") }}
    </div>
    <!-- 第一组标题 -->

    <!-- 仓库环境明细第一组 -->
    <div>
      <!-- 第一组总边距 -->
      <div style="padding: 0px 10% 0px 10%">
        <!-- 大图 -->
        <div
          style="
            display: flex;
            justify-content: space-around;
            margin-bottom: 30px;
          "
        >
          <img
            src="@/assets/company.png"
            alt="图片加载失败"
            style="width: 100%; height: auto; object-fit: cover"
          />
        </div>
        <!-- 大图 -->
        <!-- 循环6图 -->
        <div
          style="
            display: flex;
            flex-wrap: wrap;
            gap: 20px; /* 控制元素之间的间隔 */
            width: 100%;
          "
        >
          <div
            v-for="(item, index) in homeHouse1"
            :key="index"
            class="flex-item"
          >
            <div class="image-container">
              <img
                :src="item.picture1"
                alt="图片加载失败"
                class="homeHouse1-picture1"
              />
            </div>
            <div class="homeHouse1-text">
              <div class="homeHouse1-text11">{{ $t(item.text11) }}</div>
              <div class="homeHouse1-text12">{{ $t(item.text12) }}</div>
            </div>
          </div>
        </div>
        <!-- 循环6图 -->
      </div>
      <!-- 第一组总边距 -->
    </div>
    <!-- 仓库环境明细第一组 -->
    <!-- 第二组标题 -->
    <div
      style="
        margin: 0px 0px 5px 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #0067b3;
        font-size: 30px;
        font-weight: bold;
      "
    >
      {{ $t("公司介绍.叉车租赁形式") }}
    </div>
    <!-- 第二组标题 -->
    <!-- 仓库环境明细第二组 -->
    <div>
      <!-- 第二组总边距 -->
      <div style="padding: 0px 10% 0px 10%">
        <!-- 大图 -->
        <div
          style="
            display: flex;
            justify-content: space-around;
            margin-bottom: 30px;
          "
        >
          <img
            src="@/assets/company.png"
            alt="图片加载失败"
            style="width: 100%; height: auto; object-fit: cover"
          />
        </div>
        <!-- 大图 -->
        <!-- 循环3图 -->
        <div
          style="
            display: flex;
            flex-wrap: wrap;
            gap: 20px; /* 控制元素之间的间隔 */
            width: 100%;
          "
        >
          <div
            v-for="(item, index) in homeHouse2"
            :key="index"
            class="flex-item"
          >
            <div class="image-container">
              <img
                :src="item.picture2"
                alt="图片加载失败"
                class="homeHouse1-picture1"
              />
            </div>
            <div class="homeHouse1-text">
              <div class="homeHouse1-text11">{{ $t(item.text21) }}</div>
              <div class="homeHouse1-text12">{{ $t(item.text22) }}</div>
            </div>
          </div>
        </div>
        <!-- 循环3图 -->
      </div>
      <!-- 第二组总边距 -->
    </div>
    <!-- 仓库环境明细第二组 -->

    <!-- 运输 -->
    <div
      style="
        height: 145px;
        background: #0067b3;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 35px;
      "
    >
      {{ $t("公司介绍.服务体系") }}
    </div>
    <!-- 运输 -->
    <!-- 第二块左右分布 -->
    <div style="padding: 0px 10% 30px 10%">
      <!-- 下方左右两部分 -->
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: stretch;
          margin-top: 30px;
          flex-wrap: wrap;
        "
      >
        <!-- 左侧文本 -->
        <div
          style="
            flex: 1;
            padding: 0 30px 30px 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
          "
        >
          <!-- 上方文本 -->
          <div
            style="
              font-size: calc(2.5vw + 10px);
              color: #0067b3;
              font-weight: bold;
              margin-bottom: calc(1.5vw + 15px);
            "
          >
            {{ $t("公司介绍.快速可靠") }}
          </div>
          <!-- 上方文本 -->

          <!-- 下方文本 -->
          <div>
            <!-- 全球运输 -->
            <div
              style="
                font-size: calc(1.8vw + 8px);
                color: #0067b3;
                margin-bottom: calc(0.9vw + 7px);
                font-weight: bold;
              "
            >
              {{ $t("公司介绍.专业化服务") }}
            </div>
            <!-- 全球运输 -->

            <!-- 四项优势 -->
            <div>
              <div
                class="blue-circle"
                style="
                  font-size: calc(0.9vw + 5px);
                  margin-bottom: calc(0.7vw + 5px);
                "
              >
                {{ $t("公司介绍.4小时的及时响应") }}
              </div>
              <div
                class="blue-circle"
                style="
                  font-size: calc(0.9vw + 5px);
                  margin-bottom: calc(0.7vw + 5px);
                "
              >
                {{ $t("公司介绍.48小时的换车服务") }}
              </div>
              <div
                class="blue-circle"
                style="
                  font-size: calc(0.9vw + 5px);
                  margin-bottom: calc(0.7vw + 5px);
                "
              >
                {{ $t("公司介绍.完善的服务网络") }}
              </div>
              <div
                class="blue-circle"
                style="
                  font-size: calc(0.9vw + 5px);
                  margin-bottom: calc(0.7vw + 5px);
                "
              >
                {{ $t("公司介绍.专业叉车服务团队") }}
              </div>
            </div>
            <!--  四项优势 -->
          </div>
          <!-- 下方文本 -->
        </div>
        <!-- 左侧文本 -->

        <!-- 右侧图片 -->
        <div style="flex: 1; display: flex; align-items: center">
          <img src="@/assets/bigfuwu.png" style="width: 100%; height: auto" />
        </div>
        <!-- 右侧图片 -->
      </div>
      <!-- 下方左右两部分 -->
    </div>
    <!-- 第二块左右分布 -->

    <!-- 运输环境循环 -->
    <div style="padding: 0px 10% 0px 10%">
      <!-- 循环3图 -->
      <div
        style="
          display: flex;
          flex-wrap: wrap;
          gap: 20px;
          width: 100%;
          flex-wrap: nowrap;
        "
      >
        <div
          v-for="(item, index) in homeHouse3"
          :key="index"
          class="flex-item2"
        >
          <div class="image-container3">
            <img
              :src="item.picture3"
              alt="图片加载失败"
              class="homeHouse1-picture1"
            />
          </div>
          <div class="homeHouse1-text">
            <div class="homeHouse1-text11">{{ $t(item.text3) }}</div>
          </div>
        </div>
      </div>
      <!-- 循环3图 -->
    </div>
    <!-- 运输环境循环 -->

    <!-- 总 -->
  </div>
</template>

<script>
export default {
  name: "about",
  components: {},
  data() {
    return {
      homeHouse1: [
        {
          picture1:
            "https://upload-attch-1256082024.cos.ap-beijing.myqcloud.com/jf/jf_web_img/butongguige.jpg",
          text11: "公司介绍.不同规格",
          text12:
            "公司介绍.叉车载重从1吨-10吨不等,不同吨数可满足客户不同租赁要求",
        },
        {
          picture1:
            "https://upload-attch-1256082024.cos.ap-beijing.myqcloud.com/jf/jf_web_img/butongpinpai.jpg",
          text11: "公司介绍.不同品牌",
          text12: "公司介绍.TOTOTA、BT、JUNGHEINRICH、NICHIYU等为我公司的战略",
        },
        {
          picture1:
            "https://upload-attch-1256082024.cos.ap-beijing.myqcloud.com/jf/jf_web_img/duozhongleixing.jpg",
          text11: "公司介绍.多种类型",
          text12: "公司介绍.电动叉车和柴油叉车为客户带来不同环境叉车租赁需求",
        },
        {
          picture1:
            "https://upload-attch-1256082024.cos.ap-beijing.myqcloud.com/jf/jf_web_img/duokuanchexing.jpg",
          text11: "公司介绍.多款车型",
          text12:
            "公司介绍.仓储叉车，平衡重叉车，牵引车，前移式叉车，托盘车，拣选叉车等多种的叉车类型",
        },
        // {
        //   picture1:
        //     "https://www.chuf.com/assets/img/o_nas/obchodni-oddeleni.webp",
        //   text11: "服务部",
        //   text12: "我们解决所有已知的技术问题。",
        // },
        // {
        //   picture1:
        //     "https://www.chuf.com/assets/img/o_nas/obchodni-oddeleni.webp",
        //   text11: "备件",
        //   text12: "我们提供各种叉车的备件。",
        // },
      ],
      homeHouse2: [
        {
          picture2:
            "https://upload-attch-1256082024.cos.ap-beijing.myqcloud.com/jf/jf_web_img/duanqizulin.jpg",
          text21: "公司介绍.短期租赁服务",
          text22: "公司介绍.短期租赁可以按天，周，月计算",
        },
        {
          picture2:
            "https://upload-attch-1256082024.cos.ap-beijing.myqcloud.com/jf/jf_web_img/zhongchangqi.jpg",
          text21: "公司介绍.中长期租赁服务",
          text22: "公司介绍.提供中长期租赁和短期租赁相结合的灵活租赁模式",
        },
        {
          picture2:
            "https://upload-attch-1256082024.cos.ap-beijing.myqcloud.com/jf/jf_web_img/rongzixing.jpg",
          text21: "公司介绍.融资性租赁服务",
          text22: "公司介绍.在租赁期满后设备产权自动转移给租赁客户",
        },
        {
          picture2:
            "https://upload-attch-1256082024.cos.ap-beijing.myqcloud.com/jf/jf_web_img/dakehu.jpg",
          text21: "公司介绍.大客户的灵活租赁",
          text22: "公司介绍.提供叉车选型，叉车数量，叉车调配等方面的灵活组合",
        },
      ],
      homeHouse3: [
        {
          picture3:
            "https://upload-attch-1256082024.cos.ap-beijing.myqcloud.com/jf/jf_web_img/chuantong.jpg",
          text3: "公司介绍.传统服务方案",
        },
        {
          picture3:
            "https://upload-attch-1256082024.cos.ap-beijing.myqcloud.com/jf/jf_web_img/rengong.jpg",
          text3: "公司介绍.人工全责服务",
        },
        {
          picture3:
            "https://upload-attch-1256082024.cos.ap-beijing.myqcloud.com/jf/jf_web_img/tebietuijian.jpg",
          text3: "公司介绍.特别推荐：全责服务",
        },
      ],
    };
  },
  methods: {},
};
</script>

<style scoped>
.blue-circle::before {
  content: ""; /* 不需要内容，只显示边框 */
  display: inline-block; /* 设置为行内块级元素 */
  width: 10px; /* 设置圆圈的宽度 */
  height: 10px; /* 设置圆圈的高度 */
  margin-right: 5px; /* 设置圆圈和文本之间的间距 */
  border: 2px solid #0067b3; /* 设置边框颜色和粗细 */
  border-radius: 50%; /* 使边框成为圆形 */
}
.image-container {
  width: 100%;
  height: 50%; /* 保持容器高度为70% */
  overflow: hidden; /* 隐藏超出部分 */
}
.image-container3 {
  width: 100%;
  height: 70%; /* 保持容器高度为70% */
  overflow: hidden; /* 隐藏超出部分 */
}

.homeHouse1-picture1 {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 中心裁剪 */
  object-position: center; /* 确保从中心位置裁剪 */
}
.homeHouse2-picture2 {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 中心裁剪 */
  object-position: center; /* 确保从中心位置裁剪 */
}
.homeHouse3-picture3 {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 中心裁剪 */
  object-position: center; /* 确保从中心位置裁剪 */
}
.homeHouse1-text11 {
  text-align: center;
  margin-top: 10px;
  font-size: 1.25rem; /* 大约20px */
  font-weight: bold;
  margin-bottom: 0.5rem; /* 大约5px */
}

.homeHouse1-text12 {
  width: 100%; /* 设置为100%以适应容器宽度 */
  font-size: 1.125rem; /* 大约18px */
  /* margin-bottom: 1.5rem;  */
  text-align: center;
  padding: 0 10px; /* 添加内边距使文本不贴边 */
  box-sizing: border-box; /* 确保内边距不会影响整体宽度 */
}
.homeHouse2-text21 {
  text-align: center;
  margin-top: 10px;
  font-size: 1.25rem; /* 大约20px */
  font-weight: bold;
  margin-bottom: 0.5rem; /* 大约5px */
}
.homeHouse2-text22 {
  width: 100%; /* 设置为100%以适应容器宽度 */
  font-size: 1.125rem; /* 大约18px */
  margin-bottom: 1.5rem; /* 大约30px */
  text-align: center;
  padding: 0 10px; /* 添加内边距使文本不贴边 */
  box-sizing: border-box; /* 确保内边距不会影响整体宽度 */
}
.homeHouse3-text3 {
  text-align: center;
  margin-top: 10px;
  font-size: 1.25rem; /* 大约20px */
  font-weight: bold;
  margin-bottom: 0.5rem; /* 大约5px */
}
.homeHouse1-text {
  text-align: center;
}
.homeHouse2-text {
  text-align: center;
}
.homeHouse3-text {
  text-align: center;
}
.flex-item {
  display: flex;
  flex-direction: column; /* 垂直排列 */
  align-items: center; /* 居中对齐 */
  justify-content: flex-start; /* 从上到下排列 */
  flex-basis: calc(25% - 15px); /* 每个元素占父容器的四分之一宽度，并减去间隔 */
  flex-grow: 1;
  min-width: 150px; /* 设置最小宽度 */
}
.flex-item2 {
  display: flex;
  flex-direction: column; /* 垂直排列 */
  align-items: center; /* 居中对齐 */
  justify-content: flex-start; /* 从上到下排列 */
  flex-basis: calc(33% - 10px); /* 每个元素占父容器的四分之一宽度，并减去间隔 */
  flex-grow: 1;
  min-width: 150px; /* 设置最小宽度 */
}
</style>
